import { ApiStatus } from 'Constants';
import * as configSeeds from './seeds/config';
const handleConfig = request => {
  return {
    status: ApiStatus.OK,
    data: configSeeds.getConfig(request.params.pId)
  };
};
export const configHandlers = [{
  match: /config$/,
  handle: handleConfig,
  method: 'GET',
  name: 'config/base'
}];